<template>
  <div class="d3-content-container">
    <div v-if="index < 0 || !content || !content.dataType" class="static-contents">
      <div class="d3-content-notfound">
        <h6>コンテンツが見つかりませんでした。</h6>
        <p>再度バッジをスキャンしてください。</p>
      </div>
    </div>

    <template v-else-if="content.dataType == 'mp4'">
      <mp4-player :content="content"></mp4-player>
    </template>
    <template v-else-if="content.dataType == 'mp3'">
      <mp3-player :content="content"></mp3-player>
    </template>
    <template v-else-if="content.dataType == 'image'">
      <image-viewer :content="content"></image-viewer>
    </template>
    <template v-else-if="content.dataType == 'pdf'">
      <pdf-viewer :content="content"></pdf-viewer>
    </template>
    <template v-else-if="content.dataType == 'dlc_code'">
      <dlc-code-viewer :content="content"></dlc-code-viewer>
    </template>
    <template v-else-if="content.dataType == 'url_link' && content.data.isInnerFrame">
      <inner-web-viewer :content="content"></inner-web-viewer>
    </template>
    <template v-else-if="content.dataType == 'url_link' && content.data.s3Url">
      <url-link-with-signed-cookie :content="content"></url-link-with-signed-cookie>
    </template>
    <template v-else-if="content.dataType == 'youtube'">
      <youtube-player :content="content"></youtube-player>
    </template>
    <template v-else-if="content.dataType == 'questionnaire'">
      <questionnaire :content="content"></questionnaire>
    </template>
    <template v-else-if="content.dataType == 'mp4_360'">
      <mp4-player360 :content="content"></mp4-player360>
    </template>
    <template v-else>
      <div class="d3-content-notfound">
        <p>このコンテンツは対応していません。</p>
      </div>
    </template>

    <button @click="onClickBack"
            class="d3-image-viewer-back mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab"
            :class="{'mdl-button--primary': content && content.dataType == 'questionnaire'}">
      <i class="material-icons">arrow_back</i>
    </button>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Mp4Player from '../contents/Mp4Player'; // MP4プレーヤーをノンタッチ再生させるために
  import Mp3Player from '../contents/Mp3Player'; // MP3プレーヤーを飲んたッチ再生させるために

  let YoutubePlayer           = resolve=>require(['../contents/YoutubePlayer'], resolve);
  let ImageViewer             = resolve=>require(['../contents/ImageViewer'], resolve);
  let PdfViewer               = resolve=>require(['../contents/PdfViewer'], resolve);
  let DlcCodeViewer           = resolve=>require(['../contents/DlcCodeViewer'], resolve);
  let InnerWebViewer          = resolve=>require(['../contents/InnerWebViewer'], resolve);
  let Questionnaire           = resolve=>require(['../contents/Questionnaire'], resolve);
  let UrlLinkWithSignedCookie = resolve=>require(['../contents/UrlLinkWithSignedCookie'], resolve);
  let Mp4Player360            = resolve=>require(['../contents/Mp4Player360'], resolve);

  export default{
    data(){
      return {};
    },
    computed:   {
      ...mapGetters(['discData']),
      index(){
        if(this.$route && this.$route.params && this.$route.params.index >= 0){
          return parseInt(this.$route.params.index);
        }
        else{
          return -1;
        }
      },
      content(){
        if(this.index >= 0 && this.discData && this.discData.ownerContents && this.discData.ownerContents.length > 0){
          return this.discData.ownerContents[this.index];
        }
        else{
          return null;
        }
      }
    },
    methods:    {
      onClickBack(){
        let currentFullPath = this.$router.history.current.fullPath;
        this.$router.back();

        setTimeout(()=>{
          // 普通はback押すとURL変わってるけど、変わってない場合は
          // historyがないってことで、homeに遷移させる
          if(currentFullPath === this.$router.history.current.fullPath){
            this.$router.push({name: 'home'});
          }
        }, 100);
      }
    },
    mounted(){
      document.querySelector('header').style.display = 'none';
    },
    beforeDestroy(){
      document.querySelector('header').style.display = '';
    },
    components: {
      Mp4Player,
      Mp3Player,
      YoutubePlayer,
      ImageViewer,
      PdfViewer,
      DlcCodeViewer,
      InnerWebViewer,
      Questionnaire,
      UrlLinkWithSignedCookie,
      Mp4Player360
    }
  };
</script>

<style lang="scss" scoped>
  @import "../../global-variables";

  .d3-content-container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 4;
    background: $d3-black;
  }

  .d3-image-viewer-back {
    position: absolute;
    top: 0;
    left: 0;
    margin: 10px 0 0 8px;
    color: #FFF;
    z-index: 4;
  }

  .d3-content-notfound {
    color: $text-white;
    margin: 80px 0 0 20px;
  }
</style>



// WEBPACK FOOTER //
// Content.vue?af975950